(function(){
  function fmt(d){return d.toLocaleDateString(document.documentElement.lang||undefined,{month:'short',day:'numeric'})}
  function addDays(n,biz){var d=new Date(),i=0;while(i<n){d.setDate(d.getDate()+1);var w=d.getDay();if(!biz||(w!==0&&w!==6))i++}return d}
  function range(a,b,biz){var x=fmt(addDays(a,biz)),y=fmt(addDays(b,biz));return x===y?x:x+' \u2013 '+y}
  function steps(){
    document.querySelectorAll('[data-pi-steps]').forEach(function(el){
      var g=function(k){return +el.dataset[k]||0},biz=el.dataset.business==='true';
      var o=el.querySelector('[data-pi-date="order"]'),r=el.querySelector('[data-pi-date="ready"]'),d=el.querySelector('[data-pi-date="deliver"]');
      if(o) o.textContent=fmt(new Date());
      if(r) r.textContent=range(g('rMin'),Math.max(g('rMin'),g('rMax')),biz);
      if(d) d.textContent=range(g('dMin'),Math.max(g('dMin'),g('dMax')),biz);
    });
  }
  function top(c,el){while(el&&el.parentElement!==c) el=el.parentElement;return el}
  /* The block that holds the buy button: the theme's product form, or (when the form is removed) the app block that provides Buy now. */
  function buyAnchor(c){
    return top(c,c.querySelector('product-form'))||top(c,c.querySelector('.shopify-app-block, [id^="shopify-block-"]'))||top(c,c.querySelector('[id^="price-"]'));
  }
  function place(){
    var c=document.querySelector('.product__info-container'); if(!c) return;
    document.querySelectorAll('[data-d22-slot]').forEach(function(el){
      if(el.dataset.placed) return;
      var slot=el.dataset.d22Slot,a;
      if(slot==='media'){var w=document.querySelector('.product__media-wrapper');if(w){w.style.position='relative';w.appendChild(el);el.dataset.placed='1'}}
      else if(slot==='top'){a=top(c,c.querySelector('.product__title'));if(a){c.insertBefore(el,a);el.dataset.placed='1'}}
      else if(slot==='afterprice'){a=top(c,c.querySelector('[id^="price-"]'));if(a){c.insertBefore(el,a.nextSibling);el.dataset.placed='1'}}
      else if(slot==='bundle'){
        a=top(c,c.querySelector('.product-form__quantity'))||buyAnchor(c);
        if(a){var p=a.previousElementSibling;if(p&&p.hasAttribute('data-d22-offer')) a=p;c.insertBefore(el,a);el.dataset.placed='1'}
      }
      else if(slot==='beforebuy'){a=buyAnchor(c);if(a){c.insertBefore(el,a);el.dataset.placed='1'}}
      else if(slot==='afterbuy'){a=buyAnchor(c);if(a){c.insertBefore(el,a.nextSibling);el.dataset.placed='1'}}
    });
  }
  function qtyInput(){return document.querySelector('.product__info-container input.quantity__input[name="quantity"]')||document.querySelector('input.quantity__input')}
  document.addEventListener('change',function(e){
    var t=e.target;if(!t||!t.matches) return;
    if(t.matches('.pi-opt input')){var q=qtyInput();if(q){q.value=t.value;q.dispatchEvent(new Event('change',{bubbles:true}))}}
    else if(t.matches('input.quantity__input')){document.querySelectorAll('.pi-opt input').forEach(function(r){r.checked=(r.value===String(t.value))})}
  });
  function init(){place();steps()}
  init();
  window.addEventListener('load',function(){init();setTimeout(init,800)});
  document.addEventListener('shopify:section:load',init);
})();
